<template>
  <div class="scholarshipTostWrap fontw400" v-if="show">
    <div class="boxCon">
      <div class="boxT fonts24 color000">如何获取及使用奖学金</div>
      <div class="boxB fonts22 color666">
        <p>
          1.奖学金通过观看课程获取，满足观看时长后将自动进入奖学金钱包，每节课程只限获得一次奖学金，永久有效。
        </p>
        <p>
          2.奖学金可用于购买付费课程，在会员购买付费课程时也可用于抵扣费用。
        </p>
      </div>
      <div class="boxBBtn" @click="$emit('closeFun')">我知道了</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["show"],
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.scholarshipTostWrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(#000, 0.49);
  width: 100vw;
  height: 100vh;
  .boxCon {
    background-image: url("../../../../static/mine/rule.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 626px 470px;
    width: 626px;
    height: 470px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 35px 30px;
    .boxT {
      line-height: 33px;
      letter-spacing: 1px;
      margin-bottom: 133px;
    }
    .boxB {
      p {
        line-height: 30px;
        text-align: left;
        margin-bottom: 20px;
      }
    }
    .boxBBtn {
      position: absolute;
      left: 50%;
      bottom: 26px;
      transform: translateX(-50%);
      width: 163px;
      height: 48px;
      line-height: 48px;
      background: #d1b07f;
      border-radius: 5px;
      overflow: hidden;
      font-size: 16;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mine/components/scholarshipToast.vue